import { ReactNode } from "react";

type SettingRowProps = {
  label: string;
  /** One sentence on why this setting exists. */
  description?: string;
  /** The current value, shown under the description. */
  value?: ReactNode;
  /** Right side of the row, e.g. a ChangeLink. */
  action?: ReactNode;
  /** Full-width area under the row, e.g. the EditPanel while editing. */
  children?: ReactNode;
};

export function SettingRow({
  label,
  description,
  value,
  action,
  children,
}: SettingRowProps) {
  return (
    <div className="border-t border-gray-100 py-3.5 first:border-t-0 first:pt-0 last:pb-0">
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-1.5">
        <div className="min-w-0 flex-1 basis-80">
          <div className="text-sm font-medium text-gray-900">{label}</div>
          {description && (
            <p className="mt-0.5 max-w-xl text-sm text-gray-600">
              {description}
            </p>
          )}
          {value && <div className="mt-1 text-sm text-gray-900">{value}</div>}
        </div>
        {action}
      </div>
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
}
